'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Mascot } from '../../assets/Mascot.js';
import { Badge } from '../Badge/Badge.js';
import { cn } from '../../lib/cn.js';
import styles from './Avatar.module.css';
const SIZE_CLASS = {
    64: styles['size64'] ?? '',
    48: styles['size48'] ?? '',
    34: styles['size34'] ?? '',
};
function initials(name) {
    const parts = name.trim().split(/\s+/).filter(Boolean);
    if (parts.length === 0)
        return '?';
    const first = parts[0]?.[0] ?? '';
    const last = parts.length > 1 ? (parts[parts.length - 1]?.[0] ?? '') : '';
    return (first + last).toUpperCase();
}
/** Initial-letter circle avatar with a mascot fallback on image error
 * (web-performance.md: every `<img>` degrades to a placeholder, never a
 * broken-image icon), loading skeleton, and PRO badge overlay. */
export function Avatar({ name, src, size = 48, loading = false, pro = false, proLabel, className, }) {
    const [failed, setFailed] = useState(false);
    const showImage = Boolean(src) && !failed && !loading;
    return (_jsxs("span", { className: cn(styles['wrapper'], SIZE_CLASS[size], className), children: [loading ? (_jsx("span", { className: styles['skeleton'], "aria-hidden": "true" })) : showImage ? (_jsx("img", { src: src, alt: name, className: styles['image'], onError: () => setFailed(true) })) : failed ? (_jsx(Mascot, { pose: "idle", size: size >= 64 ? 80 : 26, animate: false, alt: name, className: styles['mascotFallback'] })) : (_jsx("span", { className: styles['initials'], "aria-hidden": "true", children: initials(name) })), pro && proLabel && (_jsx("span", { className: styles['proOverlay'], children: _jsx(Badge, { tone: "pro", children: proLabel }) }))] }));
}
